<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h">P<span class="smallcaps">ROLOGUE</span></p>
<p class="normal">Thornmallow was a wizard, only the most minor of wizards. He had learned some elementary Spelling and a smattering of Names. He had not yet learned his Changes thoroughly, nor his Transformations. And his Curses tended to splatter or dribble around the edges. He was rarely Punctual or Practical and his nose tended toward smudginess.</p>
<p class="indent">But he meant well. And he tried.</p>
<p class="indent">Magister Greybane of the long, thin beard was often heard to mutter when Thornmallow came for lessons in Prestonomics. Magister Beechvale had sick headaches when it was Thornmallow’s turn to chant. And even Magister Briar Rose was known to feel a bit queasy upon the occasion of Thornmallow’s exams.</p>
<p class="indent">But the fact remains that Thornmallow meant well. And he tried. He came to Wizard’s Hall at the time of its greatest peril, the 113th student, the very last to be admitted in that horrible year. And it turned out the inhabitants of Wizard’s Hall were glad indeed that Thornmallow studied there.</p>
<p class="indent">Not because he was the world’s greatest wizard.</p>
<p class="indent">But because he meant well.</p>
<p class="indent">And he tried.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?ca50dd42